import React from "react";
import {
Box,
Container,
Grid,
Column,
FooterLink,
Heading,
} from "./FooterStyles";

const Footer = () => {
return (
	<Box>
	<p  className="text* center text-white  mt-5">
		AMCOSA, a center excellence in science education in Nigeria. Academically strong and one of the top 50 schools in the country. Our top priority is to rebuild, renovate and maintain the Physics, Chemistry and Biology laboratories.Exposing students to Science, Technology, Engineering, Arts, and Mathematics.
	</p>
	<Container>
		<Grid>
		<Column>
    <div className=" text-white">
        <h5 className="foot">Contacts</h5>
        <dl className="contact-list">
          <dt>Address:</dt>
          <dd> Aweere area Molarere road ikire</dd>
        </dl>
        <dl className="contact-list">
          <dt>email:</dt>
          <dd><a className="text-white" href="mailto:103ako@gmail.com">send us mail here</a></dd>
        </dl>
        <dl className="contact-list">
          <dt>phones:</dt>
          <dd><a className="text-white" href="tel:+2348131515156">08131515156</a> <span>or</span> <a className="text-white" href="tel:+2348137954163">08137954163</a>
          </dd>
        </dl>
      </div>
		</Column>
		<Column>
			<h5  className="foot">Advert Links</h5>
			<FooterLink href="https://mypally.co">Mypally</FooterLink>
			<FooterLink href="https://akojelict.netlify.app">Akojelict</FooterLink>
			<FooterLink href="http://bit.ly/Spicehub">Spiceo</FooterLink>
			<FooterLink href="https://wa.me/23409065921033?text=">Abidola-oriflame</FooterLink>
		</Column>
		<Column>
			<h5  className="foot">Quick Links</h5>
			<FooterLink href="/who">About us</FooterLink>
			<FooterLink href="/contact">Contact us</FooterLink>
			<FooterLink href="reg">Become a member</FooterLink>
			<FooterLink href="/gallery">Gallery</FooterLink>
		</Column>
		<Column>
			<Heading>Follow Us</Heading>
			<FooterLink href="https://www.facebook.com/groups/2182329605125217/?ref=share">
			<i className="fa fa-facebook-f">
				<span style={{ marginLeft: "10px" }}>
				Facebook
				</span>
			</i>
			</FooterLink>
			<FooterLink href="#">
			<i className="fa fa-instagram">
				<span style={{ marginLeft: "10px" }}>
				Instagram
				</span>
			</i>
			</FooterLink>
			<FooterLink href="#">
			<i className="fa fa-twitter">
				<span style={{ marginLeft: "10px" }}>
				Twitter
				</span>
			</i>
			</FooterLink>
      <FooterLink href="https://chat.whatsapp.com/GShS3aL1IZSLbzTEhTMGwP">
			<i className="fa fa-whatsapp">
				<span style={{ marginLeft: "10px" }}>
				Whatsapp
				</span>
			</i>
			</FooterLink>
			
		</Column>
		</Grid>
	</Container>
	</Box>
);
};
export default Footer;
